import Notification from "./Notification.presenter";

export default Notification;
